import { configureStore } from '@reduxjs/toolkit';
import clientsReducer from './slices/clientsSlice';
import commandesReducer from './slices/commandesSlice';
import dashboardReducer from './slices/dashboardSlice';
import produitsReducer from './slices/produitsSlice';
import authReducer from './slices/authSlice';
import stockReducer from './slices/stockSlice';
import modeleBoitierReducer from './slices/modeleBoitierSlice';
import stockBoitierReducer from './slices/stockBoitierSlice';
import stockCarteSimReducer from './slices/stockCarteSimSlice';
import boitierStatusReducer from './slices/boitierStatusSlice';

export const store = configureStore({
  reducer: {
    clients: clientsReducer,
    commandes: commandesReducer,
    dashboard: dashboardReducer,
    produits: produitsReducer,
    auth: authReducer,
    stock: stockReducer,
    modelesBoitier: modeleBoitierReducer,
    stockBoitier: stockBoitierReducer,
    stockSim: stockCarteSimReducer,
    boitierStatus: boitierStatusReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
